"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MathInlineElement = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const slate_react_1 = require("slate-react");
const context_1 = require("@jsonjoy.com/ui/lib/styles/context");
const context_2 = require("../../../context");
const mathlive_1 = require("../../../void/math/mathlive");
const settings_1 = require("./settings");
const inlineClass = (0, nano_theme_1.rule)({
    d: 'inline-block',
    mr: 0,
    pd: '0 1px',
    bdrad: '3px',
    cursor: 'pointer',
    us: 'none',
});
const placeholderClass = (0, nano_theme_1.rule)({
    fz: '13px',
    lh: 1.4,
});
const MathInlineElement = ({ attributes, children, element }) => {
    const mutxt = (0, context_2.useMuTxt)();
    mutxt.things.version.use();
    const styles = (0, context_1.useStyles)();
    const isSelected = (0, slate_react_1.useSelected)();
    const isFocused = (0, slate_react_1.useFocused)();
    const selected = isSelected && isFocused;
    const thingId = element['@thing'];
    const thing = thingId ? mutxt.things.get(thingId) : undefined;
    const tex = thing?.val ?? '';
    const size = thing?.size === 'S' ? 'S' : 'M';
    const fontSize = settings_1.MATH_SIZE_FONT[size];
    const onClick = React.useCallback((event) => {
        event.preventDefault();
        event.stopPropagation();
        if (mutxt.readOnly.value)
            return;
        try {
            const path = slate_react_1.ReactEditor.findPath(mutxt.editor, element);
            mutxt.inline.math.openEdit(element, path);
        }
        catch { }
    }, [mutxt, element]);
    return (
    // biome-ignore lint/a11y/useKeyWithClickEvents: keyboard entry is handled by the Slate editor cursor
    React.createElement("span", { ...attributes, className: inlineClass, style: {
            background: selected ? 'rgba(0,127,255,.18)' : 'transparent',
            fontSize,
        }, onClick: onClick },
        React.createElement("span", { contentEditable: false }, tex ? (React.createElement(mathlive_1.MathSpan, { tex: tex, mode: "textstyle", selected: selected, focused: selected, dark: !styles.light })) : (React.createElement("span", { className: placeholderClass, style: { color: styles.g(0.5) } }, "\u2026"))),
        children));
};
exports.MathInlineElement = MathInlineElement;
